export default "__VITE_ASSET__oRd8lW1C__"